import React from 'react';
import {useSelector} from 'react-redux';
import {Button, SelectMenu, SelectMenuProps} from 'evergreen-ui';
import {
    datasourceTypesDictionarySelectorMonitoring,
    datasourceTypesIdsSelectorMonitoring
} from "../../App/Dictionaries/selectors/datasourceTypesMonitoring";

type DatasourceTypeSelect = {
    selected: number[] | undefined,
    onSelect?: (selected: number[] | undefined) => void,
}

export function DatasourceTypesSelectMonitoring({
     selected,
     onSelect,
 }: DatasourceTypeSelect) {
    const datasourceTypesIds = useSelector(datasourceTypesIdsSelectorMonitoring);
    const datasourceTypes = useSelector(datasourceTypesDictionarySelectorMonitoring);

    const options = React.useMemo(
        () => datasourceTypesIds.map((id) => ({ label: datasourceTypes[id].shortName, value: id })),
        [datasourceTypes, datasourceTypesIds],
    );

    const onSelectTypes: SelectMenuProps['onSelect'] = (item) => {
        const items = selected ? [...selected, +item.value] : [+item.value];
        onSelect && onSelect(items);
    };
    const onDeselectTypes: SelectMenuProps['onDeselect'] = (item) => {
        const items = selected
            ? selected.filter((selectedId) => selectedId !== +item.value)
            : undefined;
        onSelect && onSelect(items);
    };

    return (
        <SelectMenu
            isMultiSelect
            title="Выберите типы источников"
            options={options}
            // @ts-ignore
            selected={selected}
            filterPlaceholder="Поиск..."
            onSelect={onSelectTypes}
            onDeselect={onDeselectTypes}
        >
            <Button
                iconAfter="caption"
                appearance={selected && selected.length > 0 ? 'primary' : 'default'}
                lineHeight="normal"
            >
                Типы источников
            </Button>
        </SelectMenu>
    );
}
export const MemoDatasourceTypeSelectMonitoring = React.memo(DatasourceTypesSelectMonitoring);
MemoDatasourceTypeSelectMonitoring.displayName = 'MemoDatasourceTypeSelectMonitoring';
export default DatasourceTypesSelectMonitoring;
